import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_DESCRIPTION = 'Abha Publication offers University Study Material, Mock Tests, and Board Practice Sets for Bihar government exams like BPSC, BSSC, and more — trusted by thousands of students across India.';

// Reusable per-page meta tags (Phase 6 SEO Part A2). Renders into <head> via
// react-helmet-async at runtime — fine for Googlebot (executes JS), not
// reliable for social-preview bots that don't (documented limitation, see
// REFACTOR_PROGRESS.md).
const SEO = ({ title, description, ogImage, type = 'website' }) => {
    const fullTitle = title ? `${title} | Abha Publication` : 'Abha Publication - University Study Material, Mock Tests & Practice Sets';
    const metaDescription = description || DEFAULT_DESCRIPTION;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />

            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:type" content={type} />
            {ogImage && <meta property="og:image" content={ogImage} />}

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={metaDescription} />
            {ogImage && <meta name="twitter:image" content={ogImage} />}
        </Helmet>
    );
};

export default SEO;
